import * as React from 'react';

import { CoreRadioButtonProps } from '../internal/WixUiCoreComponents/components/CoreRadioButton/CoreRadioButton';
import { ErrorMessageWrapperProps } from '../internal/ErrorMessageWrapper';
import { LangProps } from '../../types';

export interface RadioButtonChangeEvent
  extends React.MouseEvent<HTMLDivElement> {
  value: string;
}

export interface RadioButtonClickEvent
  extends React.MouseEvent<HTMLDivElement> {
  value: string;
}

export enum RadioButtonTheme {
  Default = 'default',
  Box = 'box',
}

export interface RadioButtonProps extends LangProps {
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  value: string;
  name?: string;
  label?: string;
  error?: boolean;
  /** Appearance of error message. TextOnly | BackgroundAndBorder */
  errorAppearance?: ErrorMessageWrapperProps['errorAppearance'];
  errorMessage?: string;
  newErrorMessage?: boolean;
  theme?: RadioButtonTheme;
  /**
   * A subtext for additional information.
   */
  subtext?: string;
  suffix?: React.ReactNode;
  children?: React.ReactNode;
  onChange?: CoreRadioButtonProps['onChange'];
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  required?: boolean;
  'aria-label'?: string;
  'aria-describedby'?: string;
  'aria-labelledby'?: string;
  'data-hook'?: string;
}

export interface RadioButtonDefaultProps {
  checked: boolean;
  disabled: boolean;
  name: string;
  error: boolean;
  theme: RadioButtonTheme;
}

export interface RadioButtonState {
  focused: boolean;
}

export enum RadioButtonDataKeys {
  Disabled = 'data-disabled',
  Checked = 'data-checked',
  Focused = 'data-focused',
  Required = 'data-required',
}

export enum RadioButtonDataHooks {
  RadioButtonWrapper = 'radiobutton-wrapper',
  IconWrapper = 'icon-wrapper',
  LabelWrapper = 'label-wrapper',
  coreRadioButton = 'core-radio-button',
  SubtextWrapper = 'subtext-wrapper',
}
